import React, { useState } from 'react';
import { Player } from '@remotion/player';
import MyComponent from '../videos/SocialPost';


import '../../App.css';

const SocialPostDemo = () => {
  // Connect the state to a text field
  const [text, setText] = useState('NEW LISTING! 💯😍');
  const [closing, setClosing] = useState('Come See It!');
  const [color, setColor] = useState('#BCD400'); // Add a state for the color
  const [format, setFormat] = useState('Vertical');
  const [opacity, setOpacity] = useState('0.2');
  const handleTextChange = (e) => {
    setText(e.target.value);
  };

  const handleClosingChange = (e) => {
    setClosing(e.target.value);
  };

  const handleColorChange = (e) => {
    setColor(e.target.value);
  };

  const handleFormatChange = (e) => {
    setFormat(e.target.value);
  };

  const handleOpacityChange = (e) => {
    setOpacity(e.target.value);
  };

  let width, height;

  if (format === 'Horizontal') {
    width = 1280;
    height = 720;
  } else if (format === 'Vertical') {
    width = 540;
    height = 960;
  } else if (format === 'Square') {
    width = 720;
    height = 720;
  }

  return (



    <>


<div className='center' style={{ width:'100%', backgroundColor:'#333'}}>
          <div className='center' style={{ width:'100%', paddingTop: '5em' }}>
          <div className='center auto-scale-text-med color-primary text-center'>Custom Video Content & Templates Coming Soon!</div>
          
              <div className='flex'
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                }}>

                
                <div className='flex-row' style={{ width:'100%'}}>
                    <div className="flex-box-50 center"  style={{ backgroundColor: 'transparent', padding: '2rem' }}>

                    <div className='featured center' style={{ backgroundColor:'transparent', width:'75%'}}>
            <div className='auto-scale-text-med color-white' style={{marginTop:'0rem'}}>
            VIDEO SETTINGS
            </div>
            <div className='auto-scale-text-xs color-white' style={{marginTop:'2rem'}}>
            Opening Title
            </div>

            <div style={{ width:'80%'}}>
            <input
              type="text"
              value={text}
              onChange={handleTextChange}
              placeholder="Enter text here"
              style={{
                padding: '10px',
                width: '100%',
                height: 'auto',
                backgroundColor:'#f1f1f1',
              }}
            />
            </div>

            <div className='auto-scale-text-xs color-white' style={{marginTop:'2rem'}}>
            Closing Title
            </div>

            <div style={{ width:'80%'}}>
            <input
              type="text"
              value={closing}
              onChange={handleClosingChange}
              placeholder="Enter text here"
              style={{
                padding: '10px',
                width: '100%',
                height: 'auto',
                backgroundColor:'#f1f1f1',
              }}
            />
            </div>

            <div className='auto-scale-text-xs color-white' style={{marginTop:'1rem'}}>
            Theme Color:  
            <input style={{marginLeft:'1rem', borderRadius:'0rem', borderColor:'white' }}type="color" value={color} onChange={handleColorChange} />
            </div>
             
            
            <div className='auto-scale-text-xs color-white' style={{marginTop:'1rem'}}>
            Overlay Opacity
            </div>

            <div style={{ width:'80%'}}>
            <input
              type="range"
              min="0.0"
              max="1.0"
              step={0.01}
              value={opacity}
              onChange={handleOpacityChange}
              placeholder="0.5"
              className="opacity-input-slider"
              style={{backgroundColor: color}}
            />
            </div>

            <div className='auto-scale-text-xs color-white' style={{marginTop:'1rem'}}>
            Select Format:  
            </div>
            <select
              value={format}
              onChange={handleFormatChange}
              style={{
                borderRadius: '1rem',
                padding: '8px',
                fontSize: '1.5rem',
                width: '80%',

              }}
                >
                <option value="Square">Square</option>
                <option value="Vertical">Vertical</option>
                <option value="Horizontal">Horizontal</option>
              </select>
          </div>
                    </div>

                      
          <div className="flex-box-50 center"  style={{ backgroundColor: 'transparent', padding: '3rem'  }}>

                      <div className='VideoContainer' style={{width:'100%', height:'75vh'}}>
                <Player
                  style={{ width: '100%', height:'100%'}}
                  component={MyComponent}
                  durationInFrames={450}
                  compositionWidth={width}
                  compositionHeight={height}
                  fps={30}
                  inputProps={{
                    text,
                    color, // Pass the color state to the Player component
                    opacity,
                    closing,
                  }}
                  controls
                  loop
                  autoPlay
                />
            </div>
                    </div>
                </div>
                </div>


              </div>
            </div>



      </>
  );
};

export default SocialPostDemo;
